import React, { useEffect, useState } from "react";
import HotelDetailBreadcrumbs from "./HotelDetailBreadcrumbs";
import HotelDetailHeader from "./HotelDetailHeader";
import ModernPhotoGallery from "../ModernPhotoGallery";
import HotelDetailAbout from "./HotelDetailAbout";
import HotelDetailAmenities from "./HotelDetailAmenities";
import HotelDetailRoomList from "./HotelDetailRoomList";
import HotelDetailRules from "./HotelDetailRules";

import HotelDetailSidebar from "./HotelDetailSidebar";

const HotelDetailView = ({
    selectedHotel,
    rooms,
    hotelPhotos,
    isAuthenticated,
    navigate,
    handleBackToHotels,
    handleRoomBooking,
}) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    // Safe scroll to top when mounting the detail view
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    if (!selectedHotel) return null;

    // Build rating from actual hotel DB data
    const starRating = selectedHotel.starRating || 3;
    const ratingText = starRating >= 5 ? "Exceptional" : starRating >= 4 ? "Excellent" : starRating >= 3 ? "Very Good" : "Good";
    const currentRating = { rating: starRating.toFixed(1), totalRatings: "Verified", text: ratingText, reviews: [] };

    return (
        <div style={{ background: "#f8f9fa", minHeight: "100vh", fontFamily: "'Lato', sans-serif", overflowX: "hidden" }}>
            {/* Tighter Sticky Header */}
            <div style={{
                background: "rgba(255, 255, 255, 0.95)",
                backdropFilter: "blur(10px)",
                borderBottom: "1px solid #eee",
                position: "sticky",
                top: isMobile ? "0" : "70px",
                zIndex: 100,
                padding: "8px 0",
                boxShadow: "0 2px 15px rgba(0,0,0,0.03)"
            }}>
                <div style={{ maxWidth: "1140px", margin: "0 auto", padding: isMobile ? "0 12px" : "0 20px", display: "flex", justifyContent: "space-between", alignItems: "center", gap: isMobile ? "8px" : "0" }}>
                    <button
                        onClick={handleBackToHotels}
                        style={{ background: "none", border: "none", color: "#EE2E24", fontWeight: "800", display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: isMobile ? "0.8rem" : "0.9rem", flexShrink: 0 }}
                    >
                        <span style={{ fontSize: "1.1rem" }}>&larr;</span> Back to Hotels
                    </button>
                    <div style={{ display: "flex", gap: isMobile ? "8px" : "15px", alignItems: "center" }}>
                        {!isMobile && <span style={{ fontSize: "0.85rem", fontWeight: "700", color: "#666" }}>Starting from ₹{selectedHotel.price || "1200"}</span>}
                        <button style={{ background: "linear-gradient(135deg, #EE2E24 0%, #FFC400 100%)", color: "#fff", border: "none", borderRadius: "10px", padding: isMobile ? "7px 12px" : "8px 24px", fontWeight: "800", cursor: "pointer", fontSize: isMobile ? "0.74rem" : "0.85rem", boxShadow: "0 4px 10px rgba(238, 46, 36, 0.2)", whiteSpace: "nowrap" }}>
                            SELECT ROOMS
                        </button>
                    </div>
                </div>
            </div>

            <div style={{ maxWidth: "1140px", margin: "15px auto", padding: isMobile ? "0 10px" : "0 20px" }}>
                {/* Breadcrumbs - Tighter */}
                <div style={{ marginBottom: "10px" }}>
                    <HotelDetailBreadcrumbs city={selectedHotel.city} hotelName={selectedHotel.hotelName} isMobile={isMobile} />
                </div>

                {/* Hotel Main Header - Impactful */}
                <HotelDetailHeader
                    hotelName={selectedHotel.hotelName}
                    address={selectedHotel.address}
                    city={selectedHotel.city}
                    hotelId={selectedHotel.hotelId}
                    isMobile={isMobile}
                />

                {/* Gallery - Compact Grid */}
                <div style={{ marginBottom: "25px", borderRadius: "12px", overflow: "hidden", boxShadow: "0 8px 30px rgba(0,0,0,0.08)" }}>
                    <ModernPhotoGallery images={hotelPhotos[selectedHotel.hotelId] || []} title="" />
                </div>

                <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: isMobile ? "14px" : "30px", alignItems: "flex-start" }}>
                    {/* Left Content Column */}
                    <div style={{ flex: 1, width: "100%", minWidth: 0 }}>
                        <HotelDetailAbout
                            hotelName={selectedHotel.hotelName}
                            city={selectedHotel.city}
                            description={selectedHotel.description}
                            isMobile={isMobile}
                        />
                        <HotelDetailAmenities hotel={selectedHotel} isMobile={isMobile} />
                        <HotelDetailRoomList
                            rooms={rooms}
                            onBook={handleRoomBooking}
                            hotelPhotos={hotelPhotos[selectedHotel.hotelId] || []}
                            isMobile={isMobile}
                        />

                        <HotelDetailRules hotel={selectedHotel} isMobile={isMobile} />
                    </div>

                    {/* Right Sidebar */}
                    <HotelDetailSidebar
                        isAuthenticated={isAuthenticated}
                        hotelName={selectedHotel.hotelName}
                        address={selectedHotel.address}
                        city={selectedHotel.city}
                        hotelId={selectedHotel.hotelId}
                        onLoginClick={() => navigate("/login")}
                        isMobile={isMobile}
                    />
                </div>
            </div>
        </div>
    );
};

export default HotelDetailView;
